/* eslint-disable max-len */
import { Dispatch } from 'redux';
import { IPersonalInformation } from 'src/interfaces/personal-info';
import personalInfoService from 'src/services/personal-info.service';
import uploadProfilePictureService from 'src/services/upload-profile-picture.service';

import { PersonalInfoActionType } from '../action-types';
import { PersonalInfoAction } from '../actions';

export const getPersonalInfo = () => async (dispatch: Dispatch<PersonalInfoAction>) => {
  dispatch({
    type: PersonalInfoActionType.GET_PERSONAL_INFO,
  });

  try {
    const { data }: { data: IPersonalInformation } = await personalInfoService.getPersonalInformation();

    dispatch({
      type: PersonalInfoActionType.GET_PERSONAL_INFO_SUCCESS,
      payload: { personalInfo: data },
    });
  } catch (err: any) {
    dispatch({
      type: PersonalInfoActionType.GET_PERSONAL_INFO_FAILURE,
      payload: err.message,
    });
  }
};

export const patchPersonalInfo =
  (payload: Partial<IPersonalInformation>) => async (dispatch: Dispatch<PersonalInfoAction>) => {
    try {
      await personalInfoService.patchPersonalInformation(payload);

      dispatch({
        type: PersonalInfoActionType.PATCH_PERSONAL_INFO_SUCCESS,
        payload: { personalInfo: payload as IPersonalInformation },
      });
    } catch (err: any) {
      dispatch({
        type: PersonalInfoActionType.PATCH_PERSONAL_INFO_FAILURE,
        payload: err.message,
      });
    }
  };

export const uploadProfilePicture =
  (fd: FormData, payload: Partial<IPersonalInformation>) => async (dispatch: Dispatch<PersonalInfoAction>) => {
    try {
      const { data }: { data: string } = await uploadProfilePictureService.upload(fd, payload?.id || '');
      const personalInfoData = {
        ...payload,
        profileUrl: data,
      };
      dispatch({
        type: PersonalInfoActionType.PATCH_PERSONAL_INFO_SUCCESS,
        payload: { personalInfo: personalInfoData as IPersonalInformation },
      });
    } catch (err: any) {
      dispatch({
        type: PersonalInfoActionType.PATCH_PERSONAL_INFO_FAILURE,
        payload: err.message,
      });
    }
  };
